export const CREATE_TRANSITION_BUTTON = {
  modal: {
    confirm: 'Add',
    title: 'Add flow function',
  },
  form: {
    input: {
      label: 'Flow function name',
      placeholder: 'Type in',
    },
    select: {
      label: 'Step transitioned to (optional)',
      placeholder: 'Select step',
    },
  },
  trigger: 'Flow functions',
} as const;
